import { PaginatedRequestParams } from 'api';

export const DashboardQueryKeys = {
  all: ['wallet'] as const,
  lists: () => [...DashboardQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...DashboardQueryKeys.lists(), filters] as const,
  details: () => [...DashboardQueryKeys.all, 'detail'] as const,
  detail: (id: string, params?: PaginatedRequestParams) =>
    [...DashboardQueryKeys.details(), id, params] as const,
};
